import ProgressCounter from './components/ProgressCounter'
import Share from './components/Share'
import Clickify from './components/Clickify'
import Counter from './components/Counter'

import apConfig from "@config/349.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {ProgressCounter,Share}

export const portals = {Clickify,Counter}

